/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Transcript_Export_Group_By_Timecode_LabelInputs */



/**
* | output |
* | --- |
* | "Group Events by Timecode" |
*
* @param {Transcript_Export_Group_By_Timecode_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const transcript_export_group_by_timecode_label = /** @type {((inputs?: Transcript_Export_Group_By_Timecode_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Transcript_Export_Group_By_Timecode_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Grouper les evenements par timecode")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ereignisse nach Zeitcode gruppieren")
	if (locale === "it") return /** @type {LocalizedString} */ ("Eventi di gruppo per codice temporale")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Групповые мероприятия по временным меткам")
	if (locale === "es") return /** @type {LocalizedString} */ ("Eventos grupales por código de tiempo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("按时间码分组事件")
	if (locale === "ja") return /** @type {LocalizedString} */ ("タイムコードによるイベントのグループ化")
	if (locale === "hi") return /** @type {LocalizedString} */ ("टाइमकोड के अनुसार इवेंट्स को ग्रुप करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Eventos em grupo por código de tempo")
	return /** @type {LocalizedString} */ ("Group Events by Timecode")
});